// src/models/financeiro/Assinatura.js
export const StatusCliente = {
  Ativo: 1,
  Inativo: 2,
  EmAtraso: 3,
  Bloqueado: 4,
};

export const statusClienteOptions = [
  { value: StatusCliente.Ativo, label: 'Ativo' },
  { value: StatusCliente.Inativo, label: 'Inativo' },
  { value: StatusCliente.EmAtraso, label: 'Em Atraso' },
  { value: StatusCliente.Bloqueado, label: 'Bloqueado' },
];

export class Assinatura {
  constructor(data = {}) {
    this.id = data.id || 0;
    this.clienteId = data.clienteId || 0;
    this.filialId = data.filialId || null;
    this.valor = data.valor || 0;
    this.diaVencimento = data.diaVencimento || 1;
    this.horarioCobranca = data.horarioCobranca || '09:00:00';
    this.descricao = data.descricao || '';
    this.statusCliente = data.statusCliente || StatusCliente.Ativo;
  }
}
